import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { Box, IconButton, Menu, Paper, Stack, Tooltip } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import DownloadIcon from "@mui/icons-material/Download";
import DownloadingIcon from "@mui/icons-material/Downloading";
import DeleteFileButton from "../DeleteFileButton";
import UpdateFileButton from "../UpdateFileButton";
import RemoveFilePasswordButton from "../RemoveFilePasswordButton";
import AddFilePasswordButton from "../AddFilePasswordButton";
import { useStoreFileViewerContext } from "../../hooks/context";
import { downloadFile } from "../../utils/file";
import { parseErrorFromPangea } from "../../utils";
import DownloadFileButton from "../PreviewStoreFile/DownloadFileButton";
var FileOptions = function (_a) {
    var _b;
    var object = _a.object, onOpen = _a.onOpen, onClose = _a.onClose, displayDownloadInline = _a.displayDownloadInline;
    var theme = useTheme();
    var apiRef = useStoreFileViewerContext().apiRef;
    var _c = useState(null), optionsEl = _c[0], setOptionsEl = _c[1];
    var _d = useState(false), downloading = _d[0], setDownloading = _d[1];
    var _e = useState(null), error = _e[0], setError = _e[1];
    var handleClose = function () {
        setOptionsEl(null);
        onClose();
    };
    var handleDownloadFile = function (e) {
        if (downloading)
            return;
        setDownloading(true);
        e.stopPropagation();
        e.preventDefault();
        return downloadFile(object, apiRef)
            .then(function () {
            setDownloading(false);
            setError(null);
        })
            .catch(function (err) {
            setError(parseErrorFromPangea(err));
            setDownloading(false);
        });
    };
    if (!object.id)
        return null;
    return (_jsxs(Stack, { direction: "row", spacing: 0.5, alignItems: "center", children: [!!displayDownloadInline && (_jsx(Tooltip, { title: error, children: _jsx(IconButton, { onClick: handleDownloadFile, children: downloading ? (_jsx(DownloadingIcon, {})) : (_jsx(DownloadIcon, { color: !!error ? "error" : undefined })) }) })), _jsxs(Box, { sx: { marginLeft: "auto" }, children: [_jsx(IconButton, { onClick: function (event) {
                            if (!!onOpen)
                                onOpen();
                            setOptionsEl(event.currentTarget);
                            event.stopPropagation();
                        }, "data-testid": "VaultItem-Options-Btn", children: _jsx(MoreVertIcon, {}) }), _jsx(Menu, { open: !!optionsEl, anchorEl: optionsEl, onClose: function () { return setOptionsEl(null); }, sx: {
                            ".MuiList-root": {
                                width: "200px",
                            },
                            button: {
                                justifyContent: "start",
                                paddingLeft: 2,
                            },
                            ".MuiButton-textPrimary": {
                                color: theme.palette.text.primary,
                            },
                        }, children: _jsxs(Paper, { tabIndex: -1, onKeyDown: function (event) {
                                if (event.key === "Tab") {
                                    event.stopPropagation();
                                }
                            }, children: [!displayDownloadInline && _jsx(DownloadFileButton, { object: object }), (object === null || object === void 0 ? void 0 : object.type) !== "folder" && (_jsx(_Fragment, { children: !!(object === null || object === void 0 ? void 0 : object["vault-password-algorithm"]) ||
                                        !!((_b = object === null || object === void 0 ? void 0 : object.metadata_protected) === null || _b === void 0 ? void 0 : _b["vault-password-algorithm"]) ? (_jsx(RemoveFilePasswordButton, { object: object, onClose: handleClose })) : (_jsx(AddFilePasswordButton, { object: object, onClose: handleClose })) })), _jsx(UpdateFileButton, { object: object, onClose: handleClose }), _jsx(DeleteFileButton, { object: object, onClose: handleClose })] }) })] })] }));
};
export default FileOptions;
